import { Decoder, Encoder } from '@msgpack/msgpack'

const msgpackEncoder = new Encoder()
const msgpackDecoder = new Decoder()

export interface EventData<T extends Record<string, any>> {
  type: string
  requestId?: string
  data?: T
  error?: string
}

export function postMsgpack<T extends Record<string, any>>(target: Worker, message: EventData<T>) {
  const serialized = msgpackEncoder.encode(message)
  target.postMessage(serialized, [serialized.buffer])
}

export function receiveMsgpack<T extends Record<string, any>>(onMessage: (eventData: EventData<T>) => void) {
  return function (e: MessageEvent) {
    if (e.data instanceof Uint8Array) {
      const eventData = msgpackDecoder.decode(e.data) as EventData<T>
      onMessage(eventData)
    }
  }
}
